import { DescriptionList, GridAlpha } from '@applyboard/crystal-ui';
import React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var SideBarDescriptionList = function SideBarDescriptionList(_ref) {
  var ariaLabelledby = _ref['aria-labelledby'],
    ariaLabel = _ref['aria-label'],
    children = _ref.children;
  return _jsx(DescriptionList, {
    variant: "free",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    children: _jsx(GridAlpha, {
      columns: "39% 1fr",
      columnGap: 4,
      rowGap: 4,
      children: children
    })
  });
};